/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const HubspotSyncingEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('HUBSPOT_SYNCING_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class HubspotSyncingEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return HubspotSyncingEnabledSettingParser.decode(input).map(res => new HubspotSyncingEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return HubspotSyncingEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return HubspotSyncingEnabledSettingParser.encode(data);
    }
    static schema() {
        return HubspotSyncingEnabledSettingParser.schema();
    }
}
